import { gql } from "apollo-boost";

export const gerenciarUsuariosLocaisListQuery = gql`
query gerenciarUsuariosLocaisListQuery ( $arquivado: Boolean ) {
    usuariosLocaisList ( archived: $arquivado ) {
    id
    nome
    email
    instituicao
    cargo
    data_inicio_validade
    data_fim_validade
    grupo_local {
      id
      nome
    }
  }
}`;

export const gerenciarUsuariosLocaisArquivarMutation = gql`
  mutation gerenciarUsuariosLocaisArquivar($id: Int) {
    usuarioLocalArchive(id: $id) {
      id
    }
  }
`;

export const gerenciarUsuariosLocaisRestaurarMutation = gql`
  mutation gerenciarUsuariosLocaisRestaurar($id: Int) {
    usuarioLocalRestore(id: $id) {
      id
    }
  }
`;

export const gerenciarUsuariosLocaisOne = gql`
  query gerenciarUsuariosLocaisOne($id: Int) {
    usuarioLocalOne(id: $id) {
      id
      nome
      email
      data_inicio_validade
      data_fim_validade
      instituicao
      cargo
      grupo_local {
        id
        nome
      }
    }
  }
`;

export const gerenciarUsuariosLocaisSave = gql`
  mutation gerenciarUsuariosLocaisSave($input: UsuarioLocalInput!) {
    usuarioLocalsave(input: $input) {
      id
    }
  }
`;

export const gerenciarUsuariosLocaisGenerateNewPassword = gql`
  mutation gerenciarUsuariosLocaisGenerateNewPassword($id: Int) {
    usuarioLocalGenerateNewPassword(id: $id) {
      id
    }
  }
`;